import { Connector } from "../../../../../../types"
import { formatDateTimeFromTimestamp } from "../../../../../utils"

type Props = {
  info: Connector
  onSelect: (val: string) => void
}

const NameCell = ({ info, onSelect }: Props) => {
  const { name, created, id } = info

  return (
    <td
      className="py-4 pl-2 pr-3 cursor-pointer hover:bg-gray-50"
      style={{ minWidth: "450px", width: "40%" }}
      onClick={() => onSelect(id)}
    >
      <div className="flex items-center">
        <div>
          <div className="font-bold">{name || `Unnamed - ${id}`}</div>
          <div className="text-sm text-neutral-400 mt-1">
            Created{" "}
            {created ? formatDateTimeFromTimestamp(created, "LLL dd yyyy") : ""}
          </div>
        </div>
      </div>
    </td>
  )
}

export default NameCell
